/** Full-width "Unreconciled Data Notice" strip.
 *  Rendered directly below the Flash Report date-picker row so caveats are
 *  visible before the numbers themselves. The full explanation is behind a
 *  toggle to keep the row compact.
 */
import { useState } from "react";
import { Info, CaretDown, CaretUp } from "@phosphor-icons/react";

export default function DisclaimerBadge({ compact = false }) {
  const [open, setOpen] = useState(false);
  if (compact) {
    return (
      <span
        data-testid="disclaimer-badge-compact"
        title="Live snapshot — figures subject to change until month-end reconciliation"
        className="inline-flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.16em] bg-amber-50 text-amber-800 border border-amber-200 rounded-md px-2.5 h-10"
      >
        <Info size={12} weight="duotone" />
        Unreconciled
      </span>
    );
  }
  return (
    <div
      data-testid="disclaimer-strip"
      className="border-l-2 border-amber-700 bg-amber-50/60 rounded-r-md text-amber-900"
    >
      <button
        type="button"
        data-testid="disclaimer-badge"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 px-3 py-2.5 text-left"
      >
        <div className="flex items-center gap-2 min-w-0">
          <Info size={13} weight="duotone" className="shrink-0" />
          <p className="uppercase text-[11px] tracking-[0.2em] font-medium">
            Unreconciled data notice
          </p>
          <p className="text-[11px] font-mono text-amber-800 truncate hidden sm:block">
            · Live snapshot — figures subject to change until month-end reconciliation
          </p>
        </div>
        {open ? <CaretUp size={12} weight="bold" className="shrink-0" /> : <CaretDown size={12} weight="bold" className="shrink-0" />}
      </button>
      {open && (
        <div className="px-3 pb-3 pt-1">
          <p className="text-[11px] leading-relaxed text-[#334155] font-serif max-w-3xl">
            FLASH provides a real-time operational snapshot from live, unreconciled
            daily transaction feeds. Because it is optimised for immediate speed and decision-making,
            these metrics are subject to rolling changes unverified by Prysm Financial. As such,
            daily/weekly margins and supplier spend tables may reflect timing discrepancies or
            pending invoice match adjustments. They do not constitute verified financial statements
            and will fluctuate until standard month-end bank reconciliations are completed.
          </p>
        </div>
      )}
    </div>
  );
}
